import {useState,useEffect} from 'react'
import realtimeDB from '../Utils/api';

const useStatus = () => 
{
    const [Status, setStatus] = useState(undefined);
    const [StatusColor, setStatusColor] = useState(undefined)
    useEffect(() => 
    {
        const StatusRef=realtimeDB.ref("/ConfigList");

        StatusRef.on("value",snapshot =>
        {
            setStatus(snapshot.val().Status);
            setStatusColor(snapshot.val().StatusColor);
        });

        return () => StatusRef.off();
    }, [])

    return {Status,StatusColor}
}

export default useStatus
